import { FIELD_SIZE_XL } from "@/domains/profile/constants/field-sizes";

export function client() {
    return {
        multiline: 1,
    };
}

export function server() {
    return {
        multiple: 1,
    };
}
